<script>
  import formasPagamento from '~js/formas-pagamento';
  import tiposPagamento from '~js/tipos-pagamento';
  import 'vue-strap/dist/vue-strap-lang';
  import { datepicker } from 'vue-strap';
  import { checkbox } from 'vue-strap';
  import solicitacaoPagamentoServico from '../../../servico';

  export default {
    components: { datepicker, checkbox },
    props: {
      solicitacao: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        formasPagamento: formasPagamento,
        tiposPagamento: tiposPagamento,
        configuracao: this.$storage.configuracao(),
        moedas: [],
      }
    },
    methods: {
      validar(valido) {
        if (!valido) throw new Error("validacao com erro");

        return this.$validator.validateAll();
      },
      arrayRemove(arr, value) {
        return arr.filter(function (ele) {
          return ele.id != value;
        });
      },
      aplicaconfiguracaoweb() {
        if (this.configuracao) {
          // Visualização Formas Pagamento
          if (!this.configuracao.solPgtoDeposito)
            this.formasPagamento = this.arrayRemove(this.formasPagamento, 0);

          if (!this.configuracao.solPgtoCheque)
            this.formasPagamento = this.arrayRemove(this.formasPagamento, 1);

          if (!this.configuracao.solPgtoOP)
            this.formasPagamento = this.arrayRemove(this.formasPagamento, 2);

          if (!this.configuracao.solPgtoBoleto)
            this.formasPagamento = this.arrayRemove(this.formasPagamento, 3);

          // Visualização Tipos Pagamento
          if (!this.configuracao.solPgtoValorBruto)
            this.tiposPagamento = this.arrayRemove(this.tiposPagamento, 0);

          if (!this.configuracao.solPgtoValorLiquido)
            this.tiposPagamento = this.arrayRemove(this.tiposPagamento, 1);
        }
      },
      listaDeMoedas() {
        return solicitacaoPagamentoServico
          .listaMoedas()
          .then(moedas => {
            this.moedas = moedas;
          });
      },
      maxLengthObservacao() {
        if (this.configuracao.abreviaturaFundacao.toUpperCase() === 'FAPUNIFESP') {
          $("#descricao").attr("maxlength", this.configuracao.tamanhoComplemento);
        }
      }
    },
    mounted() {
      $('.datepicker input').attr('readonly', '');
      this.aplicaconfiguracaoweb();
      this.maxLengthObservacao();
      this.listaDeMoedas();
    },
  }
</script>

<template>
  <div>

    <div class="row">
      <div class="col-lg-12">
        <checkbox v-model="solicitacao.pagamentoDeBolsa" :true-value="true" type="success">
          <small>Este pagamento é uma bolsa</small>
        </checkbox>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-3" v-if="configuracao.exibirDataPgtoSolicitacaoPgto">
        <div class="form-group required" :class="{'has-error': errors.has('dataPagamento')}">
          <label class="control-label">Data para pagamento</label>

          <datepicker v-model="solicitacao.dataPagamento"
                      format="dd/MM/yyyy"
                      placeholder="  /  /     "
                      lang="pt-BR"
                      data-vv-name="dataPagamento"
                      data-vv-as="data para pagamento"
                      v-validate="'required|date_format:DD/MM/YYYY'">
          </datepicker>

          <p class="text-danger" v-show="errors.has('dataPagamento')">{{ errors.first('dataPagamento') }}</p>
        </div>
      </div>

      <div :class="[configuracao.exibirDataPgtoSolicitacaoPgto ? 'col-lg-3' : 'col-lg-4']">
        <div class="form-group required" :class="{'has-error': errors.has('formaPagamento')}">
          <label class="control-label" for="forma-pagamento">Forma de pagamento</label>

          <select class="form-control"
                  id="forma-pagamento"
                  v-model="solicitacao.formaPagamento"
                  data-vv-name="formaPagamento"
                  data-vv-as="forma de pagamento"
                  v-validate="'required'">
            <option value="">Selecione...</option>
            <option :value="formaPagamento.id" v-for="formaPagamento in formasPagamento">{{ formaPagamento.nome }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('formaPagamento')">{{ errors.first('formaPagamento') }}</p>
        </div>
      </div>

      <div :class="[configuracao.exibirDataPgtoSolicitacaoPgto ? 'col-lg-2' : 'col-lg-4']">
        <div class="form-group required" :class="{'has-error': errors.has('tipoPagamento')}">
          <label class="control-label" for="tipo-pagamento">Tipo</label>

          <select class="form-control"
                  id="tipo-pagamento"
                  v-model="solicitacao.tipoPagamento"
                  data-vv-name="tipoPagamento"
                  data-vv-as="tipo"
                  v-validate="'required'">
            <option value="">Selecione...</option>
            <option :value="tipoPagamento.id" v-for="tipoPagamento in tiposPagamento">{{ tipoPagamento.nome }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('tipoPagamento')">{{ errors.first('tipoPagamento') }}</p>
        </div>
      </div>

      <div class="col-lg-2">
        <div class="form-group required" :class="{'has-error': errors.has('moeda')}">
          <label class="control-label" for="moeda">Moeda</label>

          <select class="form-control"
                  id="moeda"
                  data-vv-name="moeda"
                  data-vv-as="moeda"
                  v-validate="'required'"
                  v-model="solicitacao.idMoeda">
            <option value="" selected>Selecione...</option>
            <option :value="moeda.idMoeda" v-for="moeda in moedas">{{ moeda.nomeMoeda }}</option>
          </select>
          <p class="text-danger" v-show="errors.has('moeda')">{{ errors.first('moeda') }}</p>
        </div>
      </div>

      <div class="col-lg-2">
        <div class="form-group required" :class="{'has-error': errors.has('valor')}">
          <label class="control-label" for="valor">Valor</label>

          <input type="text"
                 class="form-control text-right"
                 id="valor"
                 v-mascara="'moeda'"
                 v-model="solicitacao.rateio.valorRateio"
                 data-vv-name="valor"
                 data-vv-as="valor"
                 v-validate="'required|not_zero'">

          <p class="text-danger" v-show="errors.has('valor')">{{ errors.first('valor') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group required" :class="{'has-error': errors.has('observacao')}">
          <label class="control-label" for="descricao">Atividade/descrição serviços</label>

          <textarea class="form-control"
                    id="descricao"
                    v-model="solicitacao.observacao"
                    data-vv-name="observacao"
                    data-vv-as="atividade/descrição serviços"
                    v-validate="'required'">
          </textarea>

          <p class="text-danger" v-show="errors.has('observacao')">{{ errors.first('observacao') }}</p>
        </div>
      </div>
    </div>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-pagamento/estrangeiro-pf/componentes/compartilhado/FormDadosPagamento.vue